import {getJson, postJson, patchJson} from '@/util/ajaxUtils';
import axios from 'axios';

export function doProfile() {
    return getJson('/auth/profile');
}

export function loginByCode(code) {
    return getJson('/auth/login-by-code', {params:{code}, custom: {noAuth: true}});
}

/**
 * 修改用户密码。
 *
 * @param data 格式为 {origPass, password}
 * @return {Promise<*>}
 */
export function doResetPassword(data) {
    return patchJson('/auth/profile/pass-reset', {data});
}

export function getCaptcha() {
    return getJson('/open/captcha', {custom: {noAuth: true}});
}

export function passResetRequest(params) {
    return postJson('/password-reset/request', {params, custom: {noAuth: true}});
}

export function passResetCheck(email, code) {
    return getJson('/password-reset/request-check', {
        params: {email, code},
        custom: {
            showErrorNotification: false,
            throwError: true,
            noAuth: true,
        },
    });
}

export function passReset(data) {
    return postJson('/password-reset/reset', {data, custom: {noAuth: true}});
}
